import { useContext, createContext } from 'react';

export const IsNextEnvContext = createContext<boolean>(false);

export const useIsNextEnv = (): boolean => {
  return useContext(IsNextEnvContext);
};

export default useIsNextEnv;
